import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'config-designation',
    templateUrl: './designation.component.html'
})
export class configDesignation {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    DepartmentId = '';
    Acronym = '';
    DesignationName = '';
    DesignationTypeId = '';
    lastModifiedBy = '';
    lastModifiedDate = '';
    LevelId = '';
    ReportId = '';

    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    DepartmentTypeId = '';
    city = [];
    area = [];
    Id = '';
    addressLine1 = '';
    addressLine2 = '';

    cityArray = [];
    designationTypes = [];
    designationLevel = [];
    reportsToArray = [];


    branchAreaMapping = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetDepartments()
            .subscribe(departmentListData => {
                this.cityArray = departmentListData;
            });

        this.PaymentService.GetDesignationTypes()
            .subscribe(departmentListData => {
                this.designationTypes = departmentListData;
            });

        this.PaymentService.GetDesignationLevels()
            .subscribe(departmentListData => {
                this.designationLevel = departmentListData;
            });






        this.PaymentService.GetDesignationList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }




    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetDesignationList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.ButtonValue = 'Update';

        this.Acronym = obj["acronym"];
        this.DesignationName = obj["name"];
        this.DesignationTypeId = obj["designationTypeId"];
        this.LevelId = obj["level"];
        this.ReportId = obj["reportToId"];
        this.DepartmentId = obj["departmentId"];


        this.createdDate = obj['createdDate'];

        this.CreatedBy = obj['createdBy'];
        this.Id = obj['id'];
        this.lastModifiedBy = obj["lastModifiedBy"];
        this.lastModifiedDate = obj["lastModifiedDate"];

        this.GetReport();
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';

        this.Acronym = obj["acronym"];
        this.DesignationName = obj["name"];
        this.DesignationTypeId = obj["designationTypeId"];
        this.LevelId = obj["level"];
        this.ReportId = obj["reportToId"];
        this.DepartmentId = obj["departmentId"];


        this.createdDate = obj['createdDate'];

        this.CreatedBy = obj['createdBy'];
        this.Id = obj['id'];
        this.lastModifiedBy = obj["lastModifiedBy"];
        this.lastModifiedDate = obj["lastModifiedDate"];
    }

    reset() {
        this.viewMode = false;
        this.IsRecordUpdated = false;
        this.ButtonValue = 'Save';

        this.Acronym = '';
        this.DesignationName = '';
        this.DesignationTypeId = '';
        this.LevelId = '';
        this.ReportId = '';
        this.DepartmentId = '';


        this.createdDate = '';

        this.CreatedBy = '';
        this.Id = '';
        this.lastModifiedBy = '';
        this.lastModifiedDate = '';
    }

    memberFormSubmit() {
        if (this.Id != '') {
            let selectedAreaIds = [];
            let selectedAreaNames = [];
            let data = {
                "acronym": this.Acronym,
                "createdBy": this.CreatedBy,
                "departmentId": this.DepartmentId,
                "designationTypeId": this.DesignationTypeId,
                "id": this.Id,
                "lastModifiedBy":null,
                "level": this.LevelId,
                "name": this.DesignationName,
                "reportsTo": this.ReportId
            }
            this.PaymentService.EditDesignation(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Area Name and Code already exists.");
                    }
                });
        }
        else {

            let data = {
                "acronym": this.Acronym,
                "departmentId": this.DepartmentId,
                "designationTypeId": this.DesignationTypeId,
                "level": this.LevelId,
                "name": this.DesignationName,
                "reportsTo": this.ReportId
            }
            this.PaymentService.CreateDesignation(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("City Name and Code already exists.");
                    }
                });
        }
    }

    deleteProdutConfirm(id, i) {
        this.DepartmentTypeId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.DepartmentTypeId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.DepartmentTypeId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetDesignationList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    GetReport() {
        if (this.DepartmentId != '' && this.LevelId != '') {
            this.PaymentService.GetReportsTo(this.LevelId, this.DepartmentId)
                .subscribe(departmentListData => {
                    this.reportsToArray = departmentListData;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/configure_designation/designation.component.ts